import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import TechnologySlider from '/@/components/technology-slider';
import { _ } from '/@/locale';
import useWindowSize from '/@/utils/hooks/window-size';
import { reverse } from '/@/utils/router';

const Technologies = ({ product, productTechnologies }) => {
    const history = useNavigate();
    const windowWidth = useWindowSize().width;
    const type = product.brand.type;

    const handleViewCompleteCatalog = () => {
        history(
            reverse('catalog.Biotechnology', {
                params: { type },
            })
        );
    };

    return (
        <Stack
            direction='column'
            alignItems='center'
            spacing={3}
            sx={{ border: 1, borderRadius: 2, borderColor: '#cccccc', height: '100%', pb: 3, pt: 5 }}
        >
            <Stack sx={{ width: '91.67%', pt: windowWidth || 0 > 900 ? 2 : 6 }}>
                <Stack sx={{ m: 'auto' }}>
                    <TechnologySlider data={productTechnologies} onClick={handleViewCompleteCatalog} border={false} />
                </Stack>
            </Stack>
            <Stack sx={{ width: '91.67%' }}>
                <Button variant='contained' onClick={handleViewCompleteCatalog} sx={{ alignSelf: 'center' }}>
                    {_('Ver catálogo completo')}
                </Button>
            </Stack>
        </Stack>
    );
};

export default Technologies;
